module.exports = __webpack_public_path__ + "eb1eeaeb07c1685bad10a54f42a353bf.MP3";